import { lazy } from 'react';

export const LazyMicrosoftSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--microsoft-settings-page" */ './microsoft-settings-page'
    ),
);
